var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83939 20L1.83939 16C1.33939 15.5 0.539388 14.3 1.33939 13.5C2.33939 12.5 3.33942 11 6.83939 13.5",
    stroke: "#2B2B2C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8394 11.5L19.8394 13.5V19L27.8394 13.5L29.3394 14.5L30.3394 13.5L28.8394 11.5Z",
    fill: "#2B2B2C",
    stroke: "#2B2B2C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.33936,
    y: 11,
    width: 14,
    height: 13,
    rx: 2,
    fill: "#2B2B2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33936,
    y: 7,
    width: 9,
    height: 1.5,
    rx: 0.75,
    fill: "#2B2B2C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3394,
    y: 8,
    width: 9,
    height: 1.5,
    transform: "rotate(90 13.3394 8)",
    fill: "#2B2B2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/Oil.2374aaee64f871d35e8ec45b30e48b52.svg";
export { ForwardRef as ReactComponent };